import ProductsList from "./ProductsList";

export { default as ProductsListFragment } from "./ProductsListFragment.gql";
export default ProductsList;
